import React, { useState } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import config from '../../config';
import '../../styles/login.scss';

const LoginPanel = ({ children }) => {
  const [useLogo, setUseLogo] = useState(true);

  const renderLogo = () => {
    if (useLogo) {
      return (
        <div className="logo">
          <img
            src={`${config.apiUrl}/logo/login`}
            onError={() => {
              setUseLogo(false);
            }}
            alt="Company Logo"
          />
        </div>
      );
    }

    return (
      <div className="company-logo-container">
        <img
          alt="DSI"
          className="company-logo"
          src="https://storage.googleapis.com/dsi-portal/assets/logos/dsi-logo.png"
        />
      </div>
    );
  };

  return (
    <Row id="login-container">
      <Col md={5} lg={4} sm={6} xs={12} style={{ maxWidth: '500px' }}>
        <Card className="form-login">
          {renderLogo()}
          {children}
        </Card>
      </Col>
    </Row>
  );
};

LoginPanel.defaultProps = {};

LoginPanel.propTypes = {
  children: PropTypes.node,
};

export default LoginPanel;
